import update from 'react-addons-update'

import { questions } from '../constants/questions'
import { QUESTION_SET_RESULT } from '../actions'

const INITIAL_STATE = {
    questions,
}

function IntroQuestionsReducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case QUESTION_SET_RESULT:
            return update(state, {
                questions: {
                    [action.index]: {
                        answer: { $set: action.payload },
                    },
                },
            })
        default: return state
    }
}

export default IntroQuestionsReducer



// WEBPACK FOOTER //
// ./src/reducers/introQuestions.js